export var SENTRY_RELEASE = "ef8ecf6756561c5319a16fecd7a2ab0112ffe3a7";
